/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Ota_Apply_FailedInputs */

const en_mobile_ota_apply_failed = /** @type {(inputs: Mobile_Ota_Apply_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not restart into the update`)
};

const es_mobile_ota_apply_failed = /** @type {(inputs: Mobile_Ota_Apply_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo reiniciar con la actualización`)
};

/**
* | output |
* | --- |
* | "Could not restart into the update" |
*
* @param {Mobile_Ota_Apply_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_ota_apply_failed = /** @type {((inputs?: Mobile_Ota_Apply_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Ota_Apply_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_ota_apply_failed(inputs)
	return en_mobile_ota_apply_failed(inputs)
});